import { styled } from '@mui/material';
import MuiBox from '@mui/material/Box';

export const ContainerBreadcrumbVideo = styled(MuiBox)`
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 0 0 10px 0;
`;

export const ContainerBreadcrumbVideoBox = styled(MuiBox)`
  display: flex;

  svg {
    color: #ff891b;
    margin-right: 5px;
  }

  span {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    color: #7b7b7b;
  }
`;
